/**
 * 描述：根据指定元素计算元素位置
 * 日期：2019-05-17
 * 作者：Qian.qianchen
 */
"use strict";
angular.module("opinionPosCalculateModule", []).
directive("opinionPosCal", ["$timeout", function($timeout) {
    return {
        restrict: "A",
        repalace: false,
        scope: {
            isCalculate: "="
        },
        link: function($scope, $elem, $attrs) {
            $scope.$watch('isCalculate', function(newVal, oldVal) {
                if (newVal == true) {
                    $elem.css({ 'opacity': 0 });
                    $timeout(function() {
                        init();
                    });
                }
            });
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                var standard = $elem.parent().siblings(".exttype");
                var standardLeft = $(standard).position().left;
                var standardTop = $(standard).position().top;
                var standardWidth = $(standard).width();
                var standardHeight = $(standard).height();
                var calRight = $elem.parent().parent().parent().width() - standardLeft - (standardWidth / 2);
                calRight = calRight > 0 ? calRight : 0;
                var calTop = standardTop + standardHeight + 5;
                $elem.css({ 'right': calRight + 'px', 'opacity': 1 });
                $elem.siblings('.arrow').css({ 'right': $elem.parent().parent().parent().width() - standardLeft - (standardWidth / 2) + ($elem.width() / 2) + 'px' })
                $elem.parent().css({ 'height': ($elem.height() + 20) + 'px' });
            }
        }
    };
}]);